export { default } from './ScreenshotsCarousel'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/ScreenshotsCarousel/index.js